import './Button.css';

/* Varianten: 'fire' (gefüllt) · 'outline' · 'ghost' — mehr gibt es nicht,
   siehe Button.css und DESIGN-SYSTEM.md §6. */
export function Button({ variant = 'fire', icon, children, className = '', ...props }) {
  return (
    <button className={`btn btn-${variant} ${className}`} {...props}>
      {icon && <span className="btn-icon">{icon}</span>}
      {children}
    </button>
  );
}

export function IconButton({ icon, label, variant = 'standard', className = '', ...props }) {
  return (
    <button
      className={`icon-btn icon-btn-${variant} ${className}`}
      aria-label={label}
      title={label}
      {...props}
    >
      {icon}
    </button>
  );
}
